
const getSkanVariations = (commonCanopies, commonVariaton) => {

	return {
		'0270': {
			...commonVariaton,
			size: {
				width: 0.3,
				height: 0.14,
				depth: 0.3
			},
			paddingTop: -0.1,
			familyName: 'skan',
			related: ['0270'],
			canopy: {
				...commonCanopies,
				"10": {
					...commonCanopies['10'],
					source: '/models/canopy_skan.glb',
					size: {
						width: 0.173,
						depth: 0.173,
						height: 0.035
					},
				}
			},
			light: {
				type: 'spot',
				power: 300,
				options: { angle: Math.PI / 2.1 }
			}
		}
	}
}

export default getSkanVariations